export const debounce = <T extends {}[]>(fn: (...args: T) => void, ms = 300) => {
  let timeoutId: ReturnType<typeof setTimeout>
  return function (this: unknown, ...args: T) {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => fn.apply(this, args), ms)
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isNumber = (value: any) => typeof value === 'number'
